module.exports = __webpack_public_path__ + "static/media/backwards.13bc0322.png";